import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { routingService } from 'services/routing';
import { storageService } from 'services/storage';
import { getPath, Path } from 'urlBuilder';

export const useProtectedAuth = (redirectBackAfterLogIn?: boolean) => {
    const authenticated = storageService.authenticated();
    const location = useLocation();

    useEffect(() => {
        if (!authenticated) {
            routingService.reloadToUrl(
                getPath(Path.login, { redirectPath: redirectBackAfterLogIn ? location.pathname : undefined })
            );
        }
    }, [authenticated, location, redirectBackAfterLogIn]);

    return authenticated;
};
